function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * chartjs-chart-funnel
 * https://github.com/sgratzl/chartjs-chart-funnel
 *
 * Copyright (c) 2021 Samuel Gratzl <samu@sgratzl.com>
 */
import { BarElement, registry, BarController, Chart, CategoryScale, LinearScale } from 'chart.js';
import { merge } from 'chart.js/helpers';
import chroma from 'chroma-js';

function inBetween(v, min, max) {
  var delta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10e-6;
  return v >= Math.min(min, max) - delta && v <= Math.max(min, max) + delta;
}

function transpose(m) {
  return {
    left: m.top,
    right: m.bottom,
    top: m.left,
    bottom: m.right,
    horizontal: !m.horizontal
  };
}

var TrapezoidElement = /*#__PURE__*/function (_BarElement) {
  _inherits(TrapezoidElement, _BarElement);

  var _super = _createSuper(TrapezoidElement);

  function TrapezoidElement() {
    var _this;

    _classCallCheck(this, TrapezoidElement);

    _this = _super.apply(this, arguments);
    _this.align = 'center';
    _this.next = undefined;
    _this.previous = undefined;
    return _this;
  }

  _createClass(TrapezoidElement, [{
    key: "getBounds",
    value: function getBounds() {
      var useFinalPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var _this$getProps = this.getProps(['x', 'y', 'base', 'width', 'height', 'horizontal'], useFinalPosition),
          x = _this$getProps.x,
          y = _this$getProps.y,
          base = _this$getProps.base,
          width = _this$getProps.width,
          height = _this$getProps.height,
          horizontal = _this$getProps.horizontal;

      if (horizontal) {
        var w = Math.abs(x - base);
        var left = base - (this.align !== 'left' ? w : 0);
        var right = base + (this.align !== 'right' ? w : 0);
        var half = height / 2;
        var top = y - half;
        var bottom = y + half;
        return {
          left: left,
          top: top,
          right: right,
          bottom: bottom,
          horizontal: horizontal
        };
      } else {
        var h = Math.abs(y - base);

        var _half = width / 2;

        var _left = x - _half;

        var _right = x + _half;

        var _top = base - (this.align !== 'right' ? h : 0);

        var _bottom = base + (this.align !== 'left' ? h : 0);

        return {
          left: _left,
          top: _top,
          right: _right,
          bottom: _bottom,
          horizontal: horizontal
        };
      }
    }
  }, {
    key: "inRange",
    value: function inRange(mouseX, mouseY, useFinalPosition) {
      var bb = this.getBounds(useFinalPosition);
      var inX = mouseX == null || inBetween(mouseX, bb.left, bb.right);
      var inY = mouseY == null || inBetween(mouseY, bb.top, bb.bottom);
      return inX && inY;
    }
  }, {
    key: "inXRange",
    value: function inXRange(mouseX, useFinalPosition) {
      return this.inRange(mouseX, null, useFinalPosition);
    }
  }, {
    key: "inYRange",
    value: function inYRange(mouseY, useFinalPosition) {
      return this.inRange(null, mouseY, useFinalPosition);
    }
  }, {
    key: "getCenterPoint",
    value: function getCenterPoint(useFinalPosition) {
      var _this$getProps2 = this.getProps(['x', 'y', 'base', 'horizontal'], useFinalPosition),
          x = _this$getProps2.x,
          y = _this$getProps2.y,
          base = _this$getProps2.base,
          horizontal = _this$getProps2.horizontal;

      var r = {
        center: {
          x: horizontal ? base : x,
          y: horizontal ? y : base
        },
        left: {
          x: horizontal ? (base + x) / 2 : x,
          y: horizontal ? y : (base + y) / 2
        },
        right: {
          x: horizontal ? base - (x - base) / 2 : x,
          y: horizontal ? y : base - (y + base) / 2
        }
      }[this.align];
      return r;
    }
  }, {
    key: "tooltipPosition",
    value: function tooltipPosition(useFinalPosition) {
      return this.getCenterPoint(useFinalPosition);
    }
  }, {
    key: "getRange",
    value: function getRange(axis) {
      var _this$getProps3 = this.getProps(['width', 'height']),
          width = _this$getProps3.width,
          height = _this$getProps3.height;

      return axis === 'x' ? width : height;
    }
  }, {
    key: "computeWayPoints",
    value: function computeWayPoints() {
      var useFinalPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var dir = this.options.shrinkAnchor;
      var shrinkFraction = Math.max(Math.min(this.options.shrinkFraction, 1), 0);

      if (shrinkFraction === 0) {
        dir = 'none';
        shrinkFraction = 1;
      }

      var bounds = this.getBounds(useFinalPosition);
      var hor = bounds.horizontal;
      var nextBounds = this.next && (dir === 'top' || dir === 'middle') ? this.next.getBounds(useFinalPosition) : bounds;
      var prevBounds = this.previous && (dir === 'bottom' || dir === 'middle') ? this.previous.getBounds(useFinalPosition) : bounds;

      if (!hor) {
        bounds = transpose(bounds);
        nextBounds = transpose(nextBounds);
        prevBounds = transpose(prevBounds);
      }

      var hi = Math.floor((bounds.bottom - bounds.top) * (1 - shrinkFraction));
      var hiRest = Math.floor((bounds.bottom - bounds.top - hi) / 2);
      var points = [];
      var rPoints = [];

      if (dir === 'none' || dir === 'top') {
        points.push([bounds.left, bounds.top], [bounds.right, bounds.top]);
      } else {
        var pFraction = 1;

        if (dir === 'middle') {
          var pHiRest = Math.floor((prevBounds.bottom - prevBounds.top) * shrinkFraction * 0.5);
          pFraction = hiRest / (pHiRest + hiRest);
        }

        points.push([bounds.left + (prevBounds.left - bounds.left) * pFraction, bounds.top], [bounds.right + (prevBounds.right - bounds.right) * pFraction, bounds.top]);
      }

      if (dir === 'middle') {
        points.push([bounds.right, bounds.top + hiRest]);
        points.push([bounds.right, bounds.bottom - hiRest]);
        rPoints.push([bounds.left, bounds.top + hiRest]);
        rPoints.push([bounds.left, bounds.bottom - hiRest]);
      } else if (dir === 'top' && shrinkFraction < 1) {
        points.push([bounds.right, bounds.top + hi]);
        rPoints.push([bounds.left, bounds.top + hi]);
      } else if (dir === 'bottom' && shrinkFraction < 1) {
        points.push([bounds.right, bounds.bottom - hi]);
        rPoints.push([bounds.left, bounds.bottom - hi]);
      }

      if (dir === 'none' || dir === 'bottom') {
        points.push([bounds.right, bounds.bottom], [bounds.left, bounds.bottom]);
      } else {
        var nFraction = 1;

        if (dir === 'middle') {
          var nHiRest = Math.floor((nextBounds.bottom - nextBounds.top) * shrinkFraction * 0.5);
          nFraction = hiRest / (nHiRest + hiRest);
        }

        points.push([bounds.right + (nextBounds.right - bounds.right) * nFraction, bounds.bottom], [bounds.left + (nextBounds.left - bounds.left) * nFraction, bounds.bottom]);
      }

      points.push.apply(points, _toConsumableArray(rPoints.reverse()));

      if (!hor) {
        return points.map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              x = _ref2[0],
              y = _ref2[1];

          return [y, x];
        });
      }

      return points;
    }
  }, {
    key: "draw",
    value: function draw(ctx) {
      var options = this.options;
      ctx.save();
      ctx.beginPath();
      var points = this.computeWayPoints();
      ctx.moveTo(points[0][0], points[0][1]);

      var _iterator = _createForOfIteratorHelper(points.slice(1)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var p = _step.value;
          ctx.lineTo(p[0], p[1]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (options.backgroundColor) {
        ctx.fillStyle = options.backgroundColor;
        ctx.fill();
      }

      if (options.borderColor) {
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.stroke();
      }

      ctx.restore();
    }
  }]);

  return TrapezoidElement;
}(BarElement);

TrapezoidElement.id = 'trapezoid';
TrapezoidElement.defaults = _objectSpread(_objectSpread({}, BarElement.defaults), {}, {
  shrinkAnchor: 'top',
  shrinkFraction: 1
});
TrapezoidElement.defaultRoutes = BarElement.defaultRoutes;

function pickForegroundColorToBackgroundColor(color) {
  var blackColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#000000';
  var whiteColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '#ffffff';
  return chroma(color).luminance() > 0.5 ? blackColor : whiteColor;
}

function blues(i, n) {
  return chroma.scale('Blues')(i / (n - 1)).hex();
}

function patchController(type, config, controller) {
  var elements = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var scales = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  registry.addControllers(controller);

  if (Array.isArray(elements)) {
    registry.addElements.apply(registry, _toConsumableArray(elements));
  } else {
    registry.addElements(elements);
  }

  if (Array.isArray(scales)) {
    registry.addScales.apply(registry, _toConsumableArray(scales));
  } else {
    registry.addScales(scales);
  }

  var c = config;
  c.type = type;
  return c;
}

var FunnelController = /*#__PURE__*/function (_BarController) {
  _inherits(FunnelController, _BarController);

  var _super2 = _createSuper(FunnelController);

  function FunnelController() {
    _classCallCheck(this, FunnelController);

    return _super2.apply(this, arguments);
  }

  _createClass(FunnelController, [{
    key: "getMinMax",
    value: function getMinMax(scale, canStack) {
      var _get$call = _get(_getPrototypeOf(FunnelController.prototype), "getMinMax", this).call(this, scale, canStack),
          max = _get$call.max;

      var r = {
        center: {
          min: -max,
          max: max
        },
        left: {
          min: 0,
          max: max
        },
        right: {
          min: -max,
          max: 0
        }
      }[this.options.align];
      return r;
    }
  }, {
    key: "update",
    value: function update(mode) {
      _get(_getPrototypeOf(FunnelController.prototype), "update", this).call(this, mode);

      var meta = this._cachedMeta;
      var elements = meta.data || [];

      for (var i = 0; i < elements.length; i++) {
        elements[i].align = this.options.align;
        elements[i].next = elements[i + 1];
        elements[i].previous = elements[i - 1];
      }
    }
  }]);

  return FunnelController;
}(BarController);

FunnelController.id = 'funnel';
FunnelController.defaults = merge({}, [BarController.defaults, {
  dataElementType: TrapezoidElement.id,
  barPercentage: 1,
  align: 'center',
  categoryPercentage: 0.98
}]);
FunnelController.overrides = merge({}, [BarController.overrides, {
  plugins: {
    legend: {
      display: false
    },
    colors: {
      enabled: false
    },
    datalabels: {
      anchor: 'start',
      textAlign: 'center',
      font: {
        size: 20
      },
      color: function color(context) {
        var bgColor = context.chart.getDatasetMeta(context.datasetIndex).data[context.dataIndex].options.backgroundColor;
        return pickForegroundColorToBackgroundColor(bgColor, Chart.defaults.color, '#ffffff');
      },
      formatter: function formatter(value, context) {
        var _a, _b;

        var label = (_b = (_a = context.chart.data.labels) === null || _a === void 0 ? void 0 : _a[context.dataIndex]) !== null && _b !== void 0 ? _b : '';
        return "".concat(label, "\n").concat((value * 100).toLocaleString(), "%");
      }
    }
  },
  scales: {
    _index_: {
      display: false,
      padding: 10,
      grid: {
        display: false
      }
    },
    _value_: {
      display: false,
      beginAtZero: false,
      grace: 0,
      grid: {
        display: false
      }
    }
  },
  elements: {
    trapezoid: {
      backgroundColor: function backgroundColor(context) {
        var nData = context.chart.data.datasets[context.datasetIndex].data.length;
        return blues(context.dataIndex, nData);
      }
    }
  }
}]);

var FunnelChart = /*#__PURE__*/function (_Chart) {
  _inherits(FunnelChart, _Chart);

  var _super3 = _createSuper(FunnelChart);

  function FunnelChart(item, config) {
    _classCallCheck(this, FunnelChart);

    return _super3.call(this, item, patchController('funnel', config, FunnelController, TrapezoidElement, [CategoryScale, LinearScale]));
  }

  return FunnelChart;
}(Chart);

FunnelChart.id = FunnelController.id;
export { FunnelChart, FunnelController, TrapezoidElement, blues, pickForegroundColorToBackgroundColor };